import API from '@/services/request/page';
import FileHelper from '@/helpers/file';
import DateHelper from '@/services/date';
import i18n from '@/i18n';
import types from './types';

const PageAPI = new API();

let params = {};

const request = (commit, slug) =>
  PageAPI.emails(slug, { catchError: true, params })
    .then((response) => {
      commit(types.EMAIL_LIST_SET_LIST, response.data);
    });

const actions = {};

actions.resetEmailRequestParams = () => { params = {}; };

actions.requestEmails = ({ commit, state }) => {
  params.paginationPage = state.page;
  return request(commit, state.slug);
};

actions.getCapturedEmails = ({ dispatch, commit }, slug) => {
  commit(types.EMAIL_LIST_SET_SLUG, slug);
  dispatch('requestEmails', types.EMAIL_LIST_SET_LIST);
};

actions.getEmailsOfPage = ({ dispatch, commit }, page) => {
  commit(types.EMAIL_LIST_SET_PAGE, page);
  dispatch('requestEmails', types.EMAIL_LIST_SET_LIST);
};

actions.searchCapturedEmails = ({ commit, state }, { target }) => {
  commit(types.EMAIL_LIST_SET_PAGE, 1);
  params = { paginationPage: 1 };
  if (target.value) {
    params.query = target.value;
  }

  return request(commit, state.slug);
};

actions.exportEmails = ({ state }) =>
  PageAPI.exportEmails(state.slug, { catchError: true, responseType: 'blob' })
    .then((response) => {
      const today = DateHelper.todayFormated(i18n.t('date.simpleFormatDash'));
      const fileName = `${i18n.t('emailsList.export.fileName')} - Hotmart Pages - ${today}.csv`;
      FileHelper.download(response.data, 'text/csv', fileName);
    });

export default actions;



// WEBPACK FOOTER //
// ./src/screens/Emails/store/actions.js